import api from './api';

export const getProjectExpenses = (projectId) =>
  api.get(`/projects/${projectId}/expenses`);

export const createProjectExpense = (projectId, data) =>
  api.post(`/projects/${projectId}/expenses`, data);

export const transitionExpenseState = (expenseId, data) =>
  api.patch(`/expenses/${expenseId}/state`, data);

export const addExpenseEvidence = (expenseId, data) =>
  api.post(`/expenses/${expenseId}/evidence`, data);

export const setExpenseSplits = (expenseId, data) =>
  api.put(`/expenses/${expenseId}/splits`, data);

export const getBusinessExpenseQueue = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/accounting/expenses`, { params });
